export default "__VITE_ASSET__DFi3KInU__"